import type { CSSProperties } from 'react';

const paths = {
  home: (
    <path d="M3 11.5L12 4l9 7.5V20a1 1 0 01-1 1h-5v-6h-6v6H4a1 1 0 01-1-1z" />
  ),
  cog: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.6 1.6 0 00.32 1.76l.05.06a2 2 0 11-2.83 2.83l-.06-.05a1.6 1.6 0 00-1.76-.32 1.6 1.6 0 00-.97 1.46V21a2 2 0 11-4 0v-.1a1.6 1.6 0 00-1.05-1.46 1.6 1.6 0 00-1.76.32l-.06.05a2 2 0 11-2.83-2.83l.05-.06a1.6 1.6 0 00.32-1.76 1.6 1.6 0 00-1.46-.97H3a2 2 0 110-4h.1a1.6 1.6 0 001.46-1.05 1.6 1.6 0 00-.32-1.76l-.05-.06a2 2 0 112.83-2.83l.06.05a1.6 1.6 0 001.76.32H9a1.6 1.6 0 00.97-1.46V3a2 2 0 114 0v.1a1.6 1.6 0 00.97 1.46 1.6 1.6 0 001.76-.32l.06-.05a2 2 0 112.83 2.83l-.05.06a1.6 1.6 0 00-.32 1.76V9c.27.6.85 1 1.46 1H21a2 2 0 110 4h-.1a1.6 1.6 0 00-1.5.97z" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" />
    </>
  ),
  help: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 4M12 17.5v.01" />
    </>
  ),
  copy: (
    <>
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M5 15V5a2 2 0 012-2h10" />
    </>
  ),
  check: <path d="M5 12.5l5 5L20 7" />,
  chev: <path d="M9 6l6 6-6 6" />,
  chevDown: <path d="M6 9l6 6 6-6" />,
  plus: <path d="M12 5v14M5 12h14" />,
  star: <path d="M12 3l2.7 5.5 6 .9-4.4 4.3 1 6L12 17l-5.4 2.8 1-6L3.3 9.4l6-.9z" />,
  bolt: <path d="M13 3L4 14h6l-1 7 9-11h-6z" />,
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18" />
    </>
  ),
  arrow: <path d="M5 12h14M13 5l7 7-7 7" />,
  arrowUp: <path d="M12 19V5M5 12l7-7 7 7" />,
  link: (
    <>
      <path d="M10 14a4 4 0 005.66 0l3-3a4 4 0 00-5.66-5.66L11.5 7" />
      <path d="M14 10a4 4 0 00-5.66 0l-3 3a4 4 0 005.66 5.66L12.5 17" />
    </>
  ),
  qr: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <path d="M14 14h3v3h-3zM18 18h3v3h-3z" />
    </>
  ),
  download: <path d="M12 4v12M6 11l6 6 6-6M5 20h14" />,
  install: (
    <>
      <rect x="6" y="2" width="12" height="20" rx="2.5" />
      <path d="M11 18h2" />
    </>
  ),
  plug: (
    <>
      <path d="M9 7V3M15 7V3M6 7h12v4a6 6 0 01-12 0z" />
      <path d="M12 17v4" />
    </>
  ),
  flame: (
    <path d="M12 22c-4 0-7-3-7-7 0-3 2-5 3-6 1 1 2 2 2 4 0-3 2-6 4-9 2 3 5 7 5 11 0 4-3 7-7 7z" />
  ),
  history: <path d="M3 12a9 9 0 109-9 9 9 0 00-7 3.5M3 4v4h4M12 7v5l3 2" />,
  receipt: <path d="M5 3h14v18l-2-2-2 2-2-2-2 2-2-2-2 2-2-2zM8 8h8M8 12h8M8 16h5" />,
  gift: (
    <>
      <rect x="3" y="8" width="18" height="5" rx="1" />
      <path d="M5 13v8h14v-8M12 8v13M12 8s-2-5-5-5a2 2 0 100 5h5zM12 8s2-5 5-5a2 2 0 110 5h-5z" />
    </>
  ),
  shield: (
    <path d="M12 3c-2.5 1.5-5 2.5-8 3v7c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V6c-3-.5-5.5-1.5-8-3z" />
  ),
  lock: (
    <>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 018 0v3" />
    </>
  ),
  msg: <path d="M21 12a8 8 0 01-11.5 7.2L4 21l1.8-5.5A8 8 0 1121 12z" />,
  headset: (
    <path d="M4 14v-2a8 8 0 1116 0v2M4 14a2 2 0 002 2h1v-5H6a2 2 0 00-2 2zM20 14a2 2 0 01-2 2v0a2 2 0 01-2-2v-1a2 2 0 012-2h2zM18 16v1a3 3 0 01-3 3h-3" />
  ),
  devices: (
    <>
      <rect x="2" y="5" width="14" height="11" rx="1.5" />
      <rect x="14" y="9" width="8" height="11" rx="1.5" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6L6 18" />,
  sparkle: (
    <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5zM18 15l1 2 2 1-2 1-1 2-1-2-2-1 2-1z" />
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8v.01" />
    </>
  ),
  key: (
    <>
      <circle cx="8" cy="15" r="4" />
      <path d="M11 12l9-9M16 7l3 3M14 9l3 3" />
    </>
  ),
  refresh: <path d="M4 11a8 8 0 0114-5l2 2M20 13a8 8 0 01-14 5l-2-2M20 4v4h-4M4 20v-4h4" />,
} as const;

export type IconName = keyof typeof paths;

interface IconProps {
  name: IconName;
  size?: number;
  stroke?: string;
  sw?: number;
  fill?: string;
  style?: CSSProperties;
  className?: string;
}

export function Icon({
  name,
  size = 20,
  stroke = 'currentColor',
  sw = 1.6,
  fill = 'none',
  style,
  className,
}: IconProps) {
  const node = paths[name];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ display: 'block', flexShrink: 0, ...style }}
      className={className}
      stroke={stroke}
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={fill}
    >
      {node}
    </svg>
  );
}

interface FlagProps {
  code: string;
  size?: number;
}

const FLAG_GLYPHS: Record<string, string> = {
  de: '🇩🇪',
  lt: '🇱🇹',
  fi: '🇫🇮',
  nl: '🇳🇱',
  se: '🇸🇪',
  us: '🇺🇸',
  fr: '🇫🇷',
  jp: '🇯🇵',
  sg: '🇸🇬',
  tr: '🇹🇷',
  ee: '🇪🇪',
  is: '🇮🇸',
};

export function Flag({ code, size = 18 }: FlagProps) {
  return (
    <span style={{ fontSize: size, lineHeight: 1, fontFamily: 'system-ui' }}>
      {FLAG_GLYPHS[code] ?? '🏳️'}
    </span>
  );
}
